import "./Footer.scss";

import { Link } from "react-router-dom";

import { legalLinkItems } from "../../../../types/config/navConfig";
import { AriaLabel } from "../../../../types/enums/ariaLabels";
import { FooterCopy, FooterUrl } from "../../../../types/enums/labels";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer" role="contentinfo" aria-label={AriaLabel.SiteFooter}>
      <div className="app-footer__inner">
        <div className="app-footer__legal">
          <p className="app-footer__copy text-reset">
            ©{year} {FooterCopy.Copyright} {FooterCopy.LegalEntity}
            <br />
            {FooterCopy.StructurePrompt}{" "}
            <a
              href={FooterUrl.PwcStructure}
              target="_blank"
              rel="noopener noreferrer"
              className="app-footer__structure-link"
            >
              {FooterCopy.StructureLinkText}
            </a>{" "}
            {FooterCopy.StructureSuffix}
          </p>
        </div>
        <ul className="app-footer__links">
          {legalLinkItems.map(({ to, label }) => (
            <li key={label}>
              <Link to={to} className="app-footer__link">
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
